import { useLanguage } from '../../../contexts/LanguageContext';
import translations from '../../../i18n/translations';

export default function Hero() {
  const { language } = useLanguage();
  const t = translations[language].hero;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/48dde99e8fd8a26df059daa5a847ba45/e84ba4722d9fd863339c1d4bb8fe8eb5.png"
          alt="Data Center"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-black/70"></div>
      </div>

      {/* Animated Lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute bottom-0 left-0 w-full h-1/2 opacity-30">
          <svg className="w-full h-full" viewBox="0 0 1920 1080" fill="none">
            <path
              d="M0 800 Q480 600 960 700 T1920 600"
              stroke="#00A3FF"
              strokeWidth="2"
              className="animate-pulse"
            />
            <path
              d="M0 900 Q480 700 960 800 T1920 700"
              stroke="#00A3FF"
              strokeWidth="1.5"
              className="animate-pulse"
              style={{ animationDelay: '0.5s' }}
            />
          </svg>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            {t.title}
            <br />
            <span className="text-3xl md:text-4xl">{t.subtitle}</span>
            <br />
            <span className="text-[#00A3FF]">{t.highlight}</span>
          </h1>

          <p className="text-lg text-gray-300 leading-relaxed mb-10 max-w-2xl">
            {t.description}
          </p>

          <div className="flex flex-wrap gap-5">
            <a
              href="#contact"
              className="group px-8 py-4 bg-[#00A3FF] text-white text-base font-semibold rounded-lg hover:bg-[#0092E6] transition-all duration-300 cursor-pointer flex items-center space-x-2 whitespace-nowrap"
            >
              <span>{t.cta}</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
            </a>
            <a
              href="#services"
              className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {t.learnMore}
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
